import { effect, Injectable, signal } from '@angular/core';
import { HwdSysteem } from '../hdw-config/HdwSysteem';
import { HwdConfigService } from '../hwd-config.service';
import { init } from 'echarts';
import { MainboardType } from '../hdw-config/hdw-konfig-types';

@Injectable({
  providedIn: null
})
export class EditSystemService {

  constructor(public hdwMetaService: HwdConfigService) { 
    effect(() => {
      console.log("Edit System Service", this.system());
    })
  }

  public system = signal<HwdSysteem | undefined>(undefined, { equal: (a, b) => false });

  public stack: HwdSysteem[] = [];

  public push() {
    let s = this.system();
    if (s != undefined) {      
      this.stack.push(s.clone())
    }
  }

  public pop() {
    if (this.stack.length > 0) {
      this.system.set(this.stack.pop());
    }
  }

  public clearStack() {
    this.stack = [];
  }

  public startEditing() {
    this.system.set(undefined);
    let origSystem = this.hdwMetaService.system();
    if (origSystem != undefined) {
      this.system.set(origSystem.clone());
    }
  }

  public addRack() {
    let _system = this.system();
    if (_system != undefined) {
      let meta = this.hdwMetaService.meta();
      let rack = meta.getRackByBus(_system.getBusTypes()[_system.getBusTypes().length - 1])[0];
      this.system.update(s => {
        if (s != undefined) {
          s.addRack(rack);    
        }
        return s;
      });
    }
  }

  public init(m: MainboardType | undefined) {
    if (m == undefined) {
      this.system.set(undefined);
      return;
    }
    this.system.set(new HwdSysteem(m));
  }


}
